import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getProviders = createApiThunk<Provider[], void>({
  action: 'providers',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_PROVIDERS,
})
